export default __webpack_public_path__ + "static/media/Add-Cart.0c57ccdd.jpg";